import { render, staticRenderFns } from "./NormalList.vue?vue&type=template&id=9a95a4cc&scoped=true"
import script from "./NormalList.vue?vue&type=script&lang=js"
export * from "./NormalList.vue?vue&type=script&lang=js"
import style0 from "./NormalList.vue?vue&type=style&index=0&id=9a95a4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a95a4cc",
  null
  
)

export default component.exports